export default __webpack_public_path__ + "./images/tt.699f5488.png";